exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*,:after,:before{box-sizing:border-box}body,html{margin:0;padding:0;width:100%;height:100%;background:#f8f8f8;font-family:Poppins-Light}a{text-decoration:none}a:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/layout-main/style.css
// module id = 697
// module chunks = 0